import type { Provider, ProviderIos } from "./ports";

class Service {
  private readonly provider: Provider;

  constructor(provider: Provider) {
    this.provider = provider;
  }

  create(params: ProviderIos.Create.In) {
    return this.provider.create(params);
  }

  update(params: ProviderIos.Update.In) {
    return this.provider.update(params);
  }

  delete(params: ProviderIos.Delete.In) {
    return this.provider.delete(params);
  }

  assignRoles(params: ProviderIos.AssignRoles.In) {
    return this.provider.assignRoles(params);
  }

  get(params: ProviderIos.Get.In) {
    return this.provider.get(params);
  }

  getAll() {
    return this.provider.getAll();
  }

  getPaginated(params: ProviderIos.GetPaginated.In) {
    return this.provider.getPaginated(params);
  }
}

export { Service };
